import { GasDefaultPalette } from '@givelify/givelify-ui';

export const colorsList = GasDefaultPalette.palette.graph.colors;
export const envelopeDonutColorsList =
    GasDefaultPalette.palette.graph.envelopeDonutColors;

// TODO: Remove that
export const greyBorder = '1px solid #ccc';
